import { FormSpy } from "react-final-form";
import Box from "@material-ui/core/Box";
import TextField from '@material-ui/core/TextField';
import React from "react";
import {
  makeStyles
} from '@material-ui/core/styles';
function Remark() {

  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiInputBase-root': {
        lineHeight: "2em"
      },
    },
  }));
  const classes = useStyles();
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values, form: { mutators } }) => {
        return (
          <>
            <Box mt={1} mb={2}>
              <Box fontWeight="bold" mb={1}>
                หมายเหตุ:
              </Box>
              <Box>
              <TextField
              className={classes.root}
          id="remark-order"
          multiline
          fullWidth
          minRows={3}
          value={values.remark}
          variant="outlined"
          onChange={(e)=>mutators.updateRemark(e.target.value)}
        />
              </Box>
            </Box>
          </>
        );
      }}
    </FormSpy>
  );
}

export default Remark;
